import { ColumnDef } from '@tanstack/react-table';

import { Tag } from '@/components';
import { DirectReportsData } from '@/types/account-settings';

export const profileReportsColumns: ColumnDef<DirectReportsData>[] = [
  {
    accessorKey: 'name',
    header: 'Leader Name',
    enableSorting: false,
    cell: info => {
      const row = info.row.original;
      return (
        <div className="flex items-center gap-2">
          <img
            src={row.profileImageUrl}
            alt={row.name}
            width={32}
            height={32}
            className="rounded-full object-cover"
          />
          <div>
            <div className="flex items-center gap-1.5 mb-1">
              <p className="text-body-14-semibold text-custom-warm-grey-950">{row.name}</p>
            </div>
            <p className="text-body-12-regular text-custom-warm-grey-600">{row.jobTitle}</p>
          </div>
        </div>
      );
    },
  },
  {
    accessorKey: 'department',
    header: 'Department',
    enableSorting: false,
    cell: info => {
      const department = info.getValue<string>();
      return <Tag label={department} size="regular" color="grey" />;
    },
  },
  {
    accessorKey: 'location',
    header: 'Location',
    enableSorting: false,
    cell: info => (
      <p className="text-body-14-regular text-custom-warm-grey-950">
        {info.row.original.location ?? '—'}
      </p>
    ),
  },
  {
    accessorKey: 'tenure',
    header: 'Tenure',
    enableSorting: true,
    cell: info => (
      <p className="text-body-14-regular text-custom-warm-grey-950">{info.getValue<string>()}</p>
    ),
  },
];
